import React from "react";
import Typography from "@material-ui/core/Typography";
import { languages } from "../../constants/languages";
import Paper from "@material-ui/core/Paper";
import { withTheme } from "@material-ui/core";
import SponsorElement from "./SponsorElement";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import EditSponsorBlockContainer from "../../containers/settings/EditSponsorBlockContainer";

class SponsorBlock extends React.Component {
  onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    let sponsors =
      this.props.tournament[
        "sponsors" +
          (this.props.blockNum !== undefined
            ? this.props.blockNum.toString()
            : "")
      ] || [];
    let sponsorLinks =
      this.props.tournament[
        "sponsorLinks" +
          (this.props.blockNum !== undefined
            ? this.props.blockNum.toString()
            : "")
      ] || [];
    sponsors.forEach((s, i) => {
      if (sponsorLinks[i] === undefined) {
        sponsorLinks.push("");
      }
    });

    const [removed] = sponsors.splice(result.source.index, 1);
    sponsors.splice(result.destination.index, 0, removed);
    const [removedLink] = sponsorLinks.splice(result.source.index, 1);
    sponsorLinks.splice(result.destination.index, 0, removedLink);

    const db = window.firebase.firestore();
    const tournamentRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);
    let toUpdate = {};
    toUpdate[
      "sponsors" +
        (this.props.blockNum !== undefined
          ? this.props.blockNum.toString()
          : "")
    ] = sponsors;
    toUpdate[
      "sponsorLinks" +
        (this.props.blockNum !== undefined
          ? this.props.blockNum.toString()
          : "")
    ] = sponsorLinks;

    tournamentRef.update(toUpdate);
  };

  render() {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          paddingTop: 15,
        }}
      >
        <Paper
          style={{
            width: "100%",
            height: "100%",
          }}
        >
          <div
            style={{
              background: this.props.theme.palette.primary.main,
              display: "flex",
              alignItems: "center",
              height: 30,
              paddingLeft: 10,
              borderRadius: "4px 4px 0px 0px",
            }}
          >
            <div {...this.props.dragHandleProps} style={{ flexGrow: 10 }}>
              <Typography
                variant="body2"
                style={{
                  color: "white",
                  fontWeight: 500,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {(this.props.tournament.sponsorBlockNames || {})[
                  this.props.blockNum !== undefined ? this.props.blockNum : 0
                ] && !this.props.new
                  ? (this.props.tournament.sponsorBlockNames || {})[
                      this.props.blockNum !== undefined
                        ? this.props.blockNum
                        : 0
                    ]
                  : this.props.new
                  ? languages.tournament.newSponsorBlock
                  : languages.tournament.sponsorGroup +
                    (this.props.blockNum !== undefined
                      ? " " + (this.props.blockNum + 1).toString()
                      : " 1")}
              </Typography>
            </div>
            {!this.props.new && (
              <EditSponsorBlockContainer
                tournament={this.props.tournament}
                sponsorBlockName={
                  (this.props.tournament.sponsorBlockNames || {})[
                    this.props.blockNum !== undefined ? this.props.blockNum : 0
                  ] || ""
                }
                blockNum={
                  this.props.blockNum === undefined ? 0 : this.props.blockNum
                }
              />
            )}
          </div>
          <div style={{ display: "flex", overflowX: "auto", padding: 5 }}>
            <DragDropContext onDragEnd={this.onDragEnd}>
              <Droppable
                droppableId="sponsorElementDrop"
                direction="horizontal"
              >
                {(provided, snapshot) => {
                  return (
                    <div
                      ref={provided.innerRef}
                      style={{
                        display: "flex",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                        }}
                      >
                        {(this.props.sponsorsTemp
                          ? this.props.sponsorsTemp[
                              this.props.blockNum !== undefined
                                ? this.props.blockNum
                                : 0
                            ]
                          : this.props.tournament[
                              "sponsors" +
                                (this.props.blockNum !== undefined
                                  ? this.props.blockNum.toString()
                                  : "")
                            ] || []
                        ).map((sponsor, i) => {
                          return (
                            <Draggable
                              key={i}
                              draggableId={i.toString()}
                              index={i}
                            >
                              {(provided, snapshot) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  <SponsorElement
                                    i={i}
                                    blockNum={this.props.blockNum}
                                    sponsor={sponsor}
                                    sponsorStorageRef={
                                      this.props.sponsorStorageRef
                                    }
                                    handleUploadStart={
                                      this.props.handleUploadStart
                                    }
                                    handleUploadError={
                                      this.props.handleUploadError
                                    }
                                    handleUploadSuccess={
                                      this.props.handleUploadSuccess
                                    }
                                    handleProgress={this.props.handleProgress}
                                    allowedToUpload={this.props.allowedToUpload}
                                    tournament={this.props.tournament}
                                    toggleUpgradeDialog={
                                      this.props.toggleUpgradeDialog
                                    }
                                    toggleDeleteDialog={
                                      this.props.toggleDeleteDialog
                                    }
                                    openSponsorLinkDialog={
                                      this.props.openSponsorLinkDialog
                                    }
                                    sponsorGroup={this.props.sponsorGroup}
                                    toggleSponsorLinkDialog={
                                      this.props.toggleSponsorLinkDialog
                                    }
                                    errorMessageSponsors={
                                      this.props.errorMessageSponsors
                                    }
                                    sponsorLinksTemp={
                                      this.props.sponsorLinksTemp
                                    }
                                    isUploading={this.props.isUploading}
                                    uploadingType={this.props.uploadingType}
                                    uploadingSponsorIndex={
                                      this.props.uploadingSponsorIndex
                                    }
                                    uploadingSponsorGroup={
                                      this.props.uploadingSponsorGroup
                                    }
                                  />
                                  {provided.placeholder}
                                </div>
                              )}
                            </Draggable>
                          );
                        })}
                      </div>
                      {provided.placeholder}
                    </div>
                  );
                }}
              </Droppable>
            </DragDropContext>
            {/* {(
              this.props.tournament[
                "sponsors" +
                  (this.props.blockNum !== undefined
                    ? this.props.blockNum.toString()
                    : "")
              ] || []
            ).length < 12 && ( */}
            <SponsorElement
              new
              i=""
              blockNum={this.props.blockNum}
              sponsorStorageRef={this.props.sponsorStorageRef}
              handleUploadStart={this.props.handleUploadStart}
              handleUploadError={this.props.handleUploadError}
              handleUploadSuccess={this.props.handleUploadSuccess}
              handleProgress={this.props.handleProgress}
              allowedToUpload={this.props.allowedToUpload}
              tournament={this.props.tournament}
              toggleUpgradeDialog={this.props.toggleUpgradeDialog}
              toggleDeleteDialog={this.props.toggleDeleteDialog}
              openSponsorLinkDialog={this.props.openSponsorLinkDialog}
              sponsorGroup={this.props.sponsorGroup}
              toggleSponsorLinkDialog={this.props.toggleSponsorLinkDialog}
              errorMessageSponsors={this.props.errorMessageSponsors}
              isUploading={this.props.isUploading}
              uploadingType={this.props.uploadingType}
              uploadingSponsorIndex={this.props.uploadingSponsorIndex}
              uploadingSponsorGroup={this.props.uploadingSponsorGroup}
            />
            {/* )} */}
          </div>
        </Paper>
      </div>
    );
  }
}

export default withTheme(SponsorBlock);
